import React, { useEffect, useRef, useState } from "react";
import styled, { useTheme } from "styled-components";
import { Break, Button, Icon, Link } from "~/components-shared";
import { useTranslation } from "react-i18next";
import { CollapsableTypeEnum } from "~/types/enums";
const Wrapper = styled.div`
  ${_ref => {
  let {
    $s,
    theme
  } = _ref;
  return theme.spacing.resolve(theme, $s);
}};
  position: relative;
  overflow: hidden;
`;
const ContentWrap = styled.div`
  max-height: ${_ref2 => {
  let {
    exceeded,
    maxHeight,
    expanded
  } = _ref2;
  return exceeded && !expanded ? `${maxHeight}px` : "auto";
}};
  overflow: hidden;
`;
const Panel = styled.div`
  width: 100%;
  position: relative;
  z-index: 1;

  ${_ref3 => {
  let {
    expanded,
    theme
  } = _ref3;
  return !expanded && `
      &:after {
        content: "";
        position: absolute;
        top: -40px;
        left: 0;
        height: 40px;
        width: 100%;
        background: ${theme.colors.gradients.secondaryBackground(180)};
      }
    `;
}}
`;
const Collapsable = _ref4 => {
  let {
    s = {},
    children,
    maxHeight = 250,
    type = CollapsableTypeEnum.LINE,
    expandedText,
    collapsedText
  } = _ref4;
  const {
    t
  } = useTranslation();
  const {
    colors
  } = useTheme();
  const ref = useRef(null);
  const [expanded, setExpanded] = useState(false);
  const [heightExceeded, setHeightExceeded] = useState(false);
  const isShown = maxHeight === 0 && expanded || maxHeight > 0;
  const isPanelShown = maxHeight === 0 && children || heightExceeded;
  useEffect(() => {
    setTimeout(() => {
      if (ref.current && children) {
        const currentHeight = ref.current?.scrollHeight;
        setHeightExceeded(currentHeight > maxHeight);
      }
    }, 0);
  }, [children]);
  return /*#__PURE__*/React.createElement(Wrapper, {
    $s: s
  }, isShown && /*#__PURE__*/React.createElement(ContentWrap, {
    exceeded: heightExceeded,
    expanded: expanded,
    maxHeight: maxHeight
  }, /*#__PURE__*/React.createElement("div", {
    ref: ref
  }, children)), isPanelShown && /*#__PURE__*/React.createElement(Panel, {
    expanded: expanded
  }, type === CollapsableTypeEnum.BUTTON ? /*#__PURE__*/React.createElement(Link, {
    onClick: () => setExpanded(prev => !prev),
    weight: "medium",
    color: colors.text.secondary,
    underline: true
  }, expanded ? expandedText || t("Collapsable.seeLess") : collapsedText || t("Collapsable.seeMore")) : /*#__PURE__*/React.createElement(Break, {
    s: {
      mb: 2
    }
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: () => setExpanded(prev => !prev),
    color: "greyTransparent",
    fontSize: 3,
    "data-tooltip-id": "general-tooltip",
    "data-tooltip-content": expanded ? expandedText || t("Collapsable.seeLess") : collapsedText || t("Collapsable.seeMore"),
    s: {
      px: 4,
      py: 0
    },
    outline: false,
    display: "inline-block"
  }, /*#__PURE__*/React.createElement(Icon, {
    src: expanded ? "chevron" : "dots-vertical",
    scale: 3,
    rotate: expanded ? 0 : 90
  })))));
};
export default Collapsable;